////// Doc. //////
//////////////////

/**
 * Device detection utilities
 */

////// Lib. //////
//////////////////

// ...

///// Utils. /////
//////////////////

// ...

////// Def. //////
//////////////////

/**
 * Check if the current device is mobile
 * @param {number} breakpoint - Optional custom breakpoint (default: 1000px)
 * @returns {boolean} True if mobile, false otherwise
 */
export function isMobile(breakpoint = 1000) {
  return window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches;
}

/**
 * Check if the current device is desktop
 * @param {number} breakpoint - Optional custom breakpoint (default: 1000px)
 * @returns {boolean} True if desktop, false otherwise
 */
export function isDesktop(breakpoint = 1000) {
  return window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
}

/**
 * Get current device type
 * @param {number} breakpoint - Optional custom breakpoint (default: 1000px)
 * @returns {string} 'mobile' or 'desktop'
 */
export function getDeviceType(breakpoint = 1000) {
  return isMobile(breakpoint) ? "mobile" : "desktop";
}

/**
 * Add event listener for device type changes
 * @param {Function} callback - Callback function to execute on device type change
 * @param {number} breakpoint - Optional custom breakpoint (default: 1000px)
 * @returns {Function} Cleanup function to remove the event listener
 */
export function onDeviceTypeChange(callback, breakpoint = 1000) {
  let currentType = getDeviceType(breakpoint);
  const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);

  function handleMediaChange(event) {
    const newType = event.matches ? "mobile" : "desktop";
    if (newType !== currentType) {
      currentType = newType;
      callback(newType, event.matches);
    }
  }

  mediaQuery.addEventListener("change", handleMediaChange);

  // Return cleanup function
  return () => mediaQuery.removeEventListener("change", handleMediaChange);
}
